import * as code from '../../../helpers/code';
import * as config from '../../../helpers/code/config';

export const codeBox = state => state.box;
export const codeScript = state => code.getScript(state.box);
export const codeButtonAttribute = state => `${config.TRIGGER_BUTTON_ATTR}="${state.box.id}"`;



/** WEBPACK FOOTER **
 ** ./src/store/modules/code/getters.js
 **/